module.exports = __webpack_public_path__ + "static/media/42@2x.3f838b46.png";